// extracted by mini-css-extract-plugin
module.exports = {"PanelHeader":"PanelHeader--332zV","Col":"Col--262SQ","Hidden":"Hidden--2PDIx","Tag":"Tag--ajO5P","Description":"Description--1NK_r","Date":"Date--1LYKz","Icon":"Icon--JgBDp"};